// extracted by mini-css-extract-plugin
export default {"dr-wrapper":"Step1_dr-wrapper__FFdoU"};